module.exports = __webpack_public_path__ + "static/media/994295.b453c140.png";